<script>

import TrainingPlayer from "@/components/trainings/TrainingPlayer.vue";
import {headerState} from "@/stores/headerStore.js";
import {BIcon} from "buefy";

export default {
    components: {BIcon, TrainingPlayer},
    data() {
        return {
            training: null,
            loading: true,
        }
    },
    methods: {
        fetchTraining(trainingId) {
            this.loading = true;
            this.training = null;
            axios.get('/trainings/' + trainingId, {
                params: {
                    series_id: this.$route.params.id,
                }
            }).then((response) => {
                this.training = response.data.data;
                headerState.title = this.training.series?.name;
                headerState.subtitle = this.training.name;
            }).catch(() => {
            }).finally(() => {
                this.loading = false;
            })
        }
    },
    watch: {
        '$route.params.training_id'(newId) {
            this.fetchTraining(newId);
        }
    },
    mounted() {
        this.fetchTraining(this.$route.params.training_id);
    },
}

</script>
<template>
    <div class="trainings-show">

        <loader :loading="loading"/>

        <div v-if="!loading">
            <div class="mb-5">
                <router-link
                    :to="{name: 'training-series.show', params: {id: $route.params.id}}"
                    class="button is-text is-small p-2 has-text-grey">
                    <span class="icon is-small">
                        <b-icon icon="chevron-left"/>
                    </span>
                    <span class="has-text-weight-semibold">{{ $t('training_series.labels.back_to_list') }}</span>
                </router-link>
            </div>

            <div class="mb-4 training-description">
                {{ training.description }}
            </div>

            <TrainingPlayer v-if="training.audio_url"
                            :audio-url="training.audio_url"
                            :slides="training.images"/>

            <div class="is-flex is-justify-content-space-between mt-5">
                <router-link
                    v-if="training.prev_training_id"
                    :to="{name: 'training-series.show-training', params: {id: $route.params.id, training_id: training.prev_training_id}}"
                    class="button is-light">
                    <span class="icon"><i class="mdi mdi-chevron-left"></i></span>
                    <span>{{ $t('training_series.labels.previous_lesson') }}</span>
                </router-link>
                <span v-else></span>

                <router-link
                    v-if="training.next_training_id"
                    :to="{name: 'training-series.show-training', params: {id: $route.params.id, training_id: training.next_training_id}}"
                    class="button is-primary">
                    <span>{{ $t('training_series.labels.next_lesson') }}</span>
                    <span class="icon"><i class="mdi mdi-chevron-right"></i></span>
                </router-link>
                <span v-else></span>
            </div>
        </div>
    </div>
</template>

<style scoped>
.training-description {
    white-space: pre-line;
}
</style>
